import React from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RoutePath, STUDENT_LOAN_ROUTE_PREFIX } from 'enums/Routes';
import { ReactComponent as ChatIcon } from 'images/chat-icon.svg';
import LinkButton from 'components/LinkButton';
import { PhoneNumbers, PhoneNumbersLabels } from 'enums/PhoneNumbers';
import useLayoutTheme from 'hooks/useLayoutTheme';
import { getApplicationData } from 'selectors/getApplicationData';
import { ApplicationStatusName } from 'enums/ApplicationStatusName';
import { PartnerId } from 'enums/PartnerName';
import { RootState } from 'handlers';
import { showIntercom } from 'utils/intercom';

import Disclaimers from './Disclaimers';

import styles from './Footer.module.scss';

const Footer = ({ showDisclaimer = true }: { showDisclaimer?: boolean }) => {
  const location = useLocation();
  const { themeStyles } = useLayoutTheme();
  const { application } = useSelector(getApplicationData);
  const { partnerId: partnerName } = useSelector((state: RootState) => state.preQualificationData);
  const applicationStatus = application?.status;

  const hideContactUs =
    (location.pathname === RoutePath.OfferStatus && applicationStatus !== ApplicationStatusName.Rejected) ||
    location.pathname === RoutePath.Error;

  return (
    <div className={styles.footerContainer}>
      <div className={styles.footer}>
        {!hideContactUs && (
          <div className={styles.contactButton}>
            <ChatIcon className={clsx(styles.icon, themeStyles.chatIcon)} />
            <LinkButton
              className={themeStyles.needHelp}
              onClick={() => showIntercom()}
              isLoading={false}
              withLineHeight={false}
            >
              Need Help? Contact us Here
            </LinkButton>
          </div>
        )}

        {partnerName === PartnerId.Fpma && <span className={styles.podiatristsText}>Plannery ❤️ podiatrists</span>}

        <span className={clsx(styles.copyright, themeStyles.copyright)}>
          &#169; {new Date().getFullYear()} Plannery. All Rights Reserved
        </span>
      </div>

      {showDisclaimer && <Disclaimers />}
    </div>
  );
};

export const getPhoneNumberInfo = (
  routePath: RoutePath,
): { phoneNumber: PhoneNumbers; phoneNumberLabel: PhoneNumbersLabels } => {
  if (routePath.startsWith(STUDENT_LOAN_ROUTE_PREFIX)) {
    return { phoneNumber: PhoneNumbers.StudentLoanSupport, phoneNumberLabel: PhoneNumbersLabels.StudentLoanSupport };
  }
  return { phoneNumber: PhoneNumbers.Support, phoneNumberLabel: PhoneNumbersLabels.Support };
};

export default Footer;
